/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.gestionauditorias': 'Audit management',
  'gestionauditorias.NumeroDocumento': 'Document code',
  'gestionauditorias.FechaCreacion': 'Creation date',
  'gestionauditorias.BodegaOrigenDescripcion': 'Bodega origin description',
  'gestionauditorias.BodegaDestinoDescripcion': 'Destination winery description',
  'gestionauditorias.DocumentoRelacionado': 'Related document',
  'gestionauditorias.EstadoDocumento': 'Document status',
  'gestionauditorias.datosDocumento': 'Document data',
  'gestionauditorias.detallesDelDocumento': 'Document details',
  'gestionauditorias.Bodegas': 'Warehouse',
  'gestionauditorias.FechaInicial': 'Initial date',
  'gestionauditorias.FechaFinal': 'Final date',
  'gestionauditorias.BodegaId': 'Warehouse',
  'gestionauditorias.DivisionId': 'Division',
  'gestionauditorias.observaciones': 'Observations',
  'gestionauditorias.ConteoUnico': 'Single count',
  'gestionauditorias.GenerarSaldoActual': 'Generate current balance',
  'gestionauditorias.PersonaCreacion': 'Associated people',
  'gestionauditorias.busquedaDetalles': 'Search details',
  'gestionauditorias.modificarEtapa': 'Change stage',
  'gestionauditorias.Detalles.CodigoBarras': 'Barcode',
  'gestionauditorias.Detalles.DescripcionItem': 'Item description',
  'gestionauditorias.Detalles.CantidadRecibida': 'Count amount 1',
  'gestionauditorias.Detalles.CantidadEntregada': 'Count amount 2',
  'gestionauditorias.Detalles.CantidadActual': 'Inventory Quantity',
  'gestionauditorias.Detalles.DescripcionDivisionOrigen': 'Division',
  'gestionauditorias.Detalles.DescripcionDivisionDestino': 'Division destination',
  'gestionauditorias.Detalles.Serial': 'Serial',
  'gestionauditorias.Detalles.Lote': 'Lot',
  'gestionauditorias.Detalles.FechaVencimiento': 'Expiration date',
  'gestionauditorias.Detalles.Division': 'Division',
  'gestionauditorias.Detalles.crearDetalleDocumento': 'Create detail document',
  'gestionauditorias.Detalles.editarDetalleDocumento': 'Edit detail document',
  'gestionauditorias.boton.administrarConteos': 'Edit state count',
  'gestionauditorias.boton.generarDiferencias': 'Generate differences',
  'gestionauditorias.titulo.productoSinContar': 'Products without counting',
  'gestionauditorias.titulo.editarDetallesAuditoria': 'Edit audit details',
  'gestionauditorias.titulo.crearAuditoria': 'Create audit',
  'gestionauditorias.titulo.editarAuditoria': 'Edit audit',
  'gestionauditorias.alerta.fechasInicialInvalida': 'The initial date must be less than the final date',
  'gestionauditorias.alerta.fechaIncompleta': 'Enter the two dates to be able to perform the search',
  'gestionauditorias.alerta.primerConteo': 'Are you sure you want to start the first count?',
  'gestionauditorias.alerta.segundoConteo': 'Are you sure you want to start the second count?',
  'gestionauditorias.alerta.finalizarConteo': 'Are you sure you want to end the count?',
  'gestionauditorias.alerta.iniciarAuditoria':
    'You cannot add or modify audit detail if it has not been started, check please.',
  'gestionauditorias.alerta.anular': 'Are you sure you want to cancel the document?',
  'gestionauditorias.FamiliaId': 'Family',
  'gestionauditorias.ItemId': 'Product',
};
